import React from 'react';

const AddLibrarySvg = () => {
  return (
    <svg
      className="Icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
    >
      <symbol xmlns="http://www.w3.org/2000/svg" id="93773" viewBox="0 0 18 18">
        <path d="M17.528 4.329a1.547 1.547 0 0 0-1.135-.472H5.464a1.612 1.612 0 0 0-1.607 1.607v10.929A1.612 1.612 0 0 0 5.464 18h10.929A1.612 1.612 0 0 0 18 16.393V5.464a1.547 1.547 0 0 0-.472-1.135Zm-.814 12.064a.326.326 0 0 1-.321.321H5.464a.326.326 0 0 1-.321-.321V5.464a.326.326 0 0 1 .321-.321h10.929a.326.326 0 0 1 .321.321ZM1.286 1.607a.326.326 0 0 1 .321-.321H2V0h-.393A1.547 1.547 0 0 0 .472.472 1.547 1.547 0 0 0 0 1.607V2h1.286ZM8 0H6v1.286h2Zm3 0H9v1.286h2ZM1.286 3H0v2h1.286Zm11.476-1.619a.309.309 0 0 1 .1.226v1.25h1.286v-1.25a1.548 1.548 0 0 0-.477-1.135A1.548 1.548 0 0 0 12.536 0H12v1.286h.536a.309.309 0 0 1 .226.095ZM5 0H3v1.286h2ZM1.286 6H0v2h1.286Zm.1 6.762a.309.309 0 0 1-.1-.226V12H0v.536a1.547 1.547 0 0 0 .472 1.135 1.547 1.547 0 0 0 1.135.472h1.25v-1.286h-1.25a.309.309 0 0 1-.226-.095ZM1.286 9H0v2h1.286Z" />
      </symbol>
      <use xlinkHref="#93773" />
    </svg>
  );
};

export default AddLibrarySvg;
